import styled from "@emotion/styled";
import colors from "styles/colors";
import authBG from "assets/auth-bg.png";

export const Container = styled.div`
  font-size: 1.4rem;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${authBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  & > svg {
    margin-bottom: 2rem;
    height: 8rem;
    width: 16rem;
  }
`;

export const FormContainer = styled.div`
  max-width: 506px;
  width: 90%;
  padding: 5.6rem 6.8rem;
  background-color: ${colors.white};
  border: 0.5px solid #ededed;
  border-radius: 8px;

  h2 {
    font-size: 34px;
    line-height: 1.2;
    text-align: center;
    font-weight: bold;
    margin-bottom: 4rem;
    color: ${colors.primary};
  }

  h3 {
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    margin-bottom: 28px;
    color: ${colors.primary};
  }

  footer {
    margin-top: 28px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    color: ${colors.primary};
    a {
      font-weight: bold;

      &:hover,
      &:focus {
        text-decoration: underline;
      }
    }
  }
`;

export const Button = styled.button`
  width: 100%;
  outline: none !important;
  border: none;
  height: 48px;
  border-radius: 4px;
  color: ${colors.white};
  font-weight: 700;
  cursor: pointer;
  background: ${colors.primary};
  background-position: right bottom;
  transition: transform 0.3s ease;

  &:hover,
  &:focus {
    transform: translateY(-2px);
  }

  svg {
    animation: rotate 1.2s linear infinite;
    margin: 0 auto;
    font-size: 17px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;
